/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CatalogResponseDto,
  CreateSubscriptionResponseDto,
  CreateTopUpSessionRequestDto,
  CreditSettingsDto,
  CustomQuotaRequestDto,
  PackToTeamDto,
  ProblemDetails,
  ProjectResponseDto,
  SceneResponseDto,
  ServiceAccountCreateRequestDto,
  ServiceAccountCredentialCreateRequestDto,
  ServiceAccountCredentialCreatedResponseDto,
  ServiceAccountCredentialResponseDto,
  ServiceAccountResponseDto,
  ServiceAccountUpdateRequestDto,
  SubscriptionInvoiceResponseDto,
  TeamCreateRequestDto,
  TeamCreateResponseDto,
  TeamCreditGrantsDto,
  TeamCreditsDto,
  TeamFoldersResponseDto,
  TeamResponseDto,
  TeamSettingDto,
  TeamUpdateRequestDto,
  TeamUsersResponseDto,
  UserTeamResponseDto,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Teams<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * @description Returns the team's spendable credit balance plus the current monthly allotment usage (allotment, used, resetsAt) for the balance chip and Billing credits card. **Permissions:** Team members; SuperAdmin/ReadOnlySuperAdmin/SupportAgent may read any team (admin console and support automation). **Returns:** - HTTP `200 OK` with the team's credits. - HTTP `401 Unauthorized` if the user is not authenticated. - HTTP `500 InternalServerError` for any server-side issues.
   *
   * @tags Credits
   * @name CreditsList
   * @summary Retrieve a team's credit balance and monthly usage
   * @request GET:/teams/{teamId}/credits
   * @secure
   */
  creditsList = (teamId: string, params: RequestParams = {}) =>
    this.request<TeamCreditsDto, ProblemDetails | void>({
      path: `/teams/${teamId}/credits`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Returns the grant blocks behind a team's balance, newest first - the audit trail: what was granted, from which source (`MonthlyAllotment`, `TopUpManual`, `TopUpAuto`, `Promo`), against which reference, how much is left, whether it has expired, and the operator who issued it for hand-made grants. Amounts appear both as whole credits and as microcredits; reconciling blocks against a balance requires the microcredit figures, since metered AI usage burns fractions of a credit. Unlike the balance read, this does **not** materialize the current monthly allotment - an audit reports the ledger as it stands rather than minting a block by being looked at. **Permissions:** SuperAdmin, ReadOnlySuperAdmin and SupportAgent only (also enforced by the JWT middleware route list). Team membership does not grant access. **Returns:** - HTTP `200 OK` with the team's grant blocks. A full page back means older grants exist. - HTTP `401 Unauthorized` / `403 Forbidden` for non-admin callers. - HTTP `500 InternalServerError` for any server-side issues.
   *
   * @tags Credits
   * @name CreditsGrantsList
   * @summary List a team's credit grants (admin)
   * @request GET:/teams/{teamId}/credits/grants
   * @secure
   */
  creditsGrantsList = (
    teamId: string,
    query?: {
      /**
       * @format int32
       * @default 100
       */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<TeamCreditGrantsDto, ProblemDetails | void>({
      path: `/teams/${teamId}/credits/grants`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a one-time (payment-mode) Stripe Checkout session for a credit top-up and returns the redirect URL. Credits are computed server-side from the amount (catalog bucket bonus if it matches, else the base type-in rate). **Permissions:** Team Owner only. **Returns:** - HTTP `200 OK` with the Checkout redirect URL. - HTTP `400 BadRequest` for an invalid amount/URLs or a non-owner caller. - HTTP `401 Unauthorized` if the user is not authenticated.
   *
   * @tags Credits
   * @name CreditsTopupSessionCreate
   * @summary Start a one-time credit top-up checkout
   * @request POST:/teams/{teamId}/credits/topup-session
   * @secure
   */
  creditsTopupSessionCreate = (
    teamId: string,
    data: CreateTopUpSessionRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<CreateSubscriptionResponseDto, ProblemDetails>({
      path: `/teams/${teamId}/credits/topup-session`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns the team's auto-top-up config, monthly spend cap, and alert emails (defaults when unset). **Permissions:** Team Owner only.
   *
   * @tags Credits
   * @name CreditsSettingsList
   * @summary Retrieve a team's credit spend settings
   * @request GET:/teams/{teamId}/credits/settings
   * @secure
   */
  creditsSettingsList = (teamId: string, params: RequestParams = {}) =>
    this.request<CreditSettingsDto, ProblemDetails>({
      path: `/teams/${teamId}/credits/settings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Upserts the team's auto-top-up config, monthly spend cap, and alert emails, and returns the persisted settings. **Permissions:** Team Owner only.
   *
   * @tags Credits
   * @name CreditsSettingsUpdate
   * @summary Update a team's credit spend settings
   * @request PUT:/teams/{teamId}/credits/settings
   * @secure
   */
  creditsSettingsUpdate = (
    teamId: string,
    data: CreditSettingsDto,
    params: RequestParams = {},
  ) =>
    this.request<CreditSettingsDto, ProblemDetails>({
      path: `/teams/${teamId}/credits/settings`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a machine principal owned by the team. **Behavior:** - Generates an address on a reserved, DNS-blackholed domain (`name@{teamId}.svc.trace3d.app`). No confirmation email is sent and no inbox exists. - The principal joins the team as an ordinary member at the requested permission, capped at the caller's own. - It cannot be signed in to: the password grant, Google, Apple, refresh, impersonation and password reset all refuse it. - It does not consume a paid seat and is exempt from downgrade pruning. **Returns:** `ServiceAccountResponseDto`. Credentials are issued in a later phase — this creates the principal only. **Permission:** Team Owner. **Error Codes:** `400 BadRequest` - Team not found, invalid name or permission, or the name is already taken in this team. `401 Unauthorized` - Caller not authenticated. `403 Forbidden` - Caller is not an owner of the team, or asked for more permission than they hold. `500 InternalServerError` - Unexpected error.
   *
   * @tags ServiceAccounts
   * @name ServiceAccountsCreate
   * @summary Create a Service Account
   * @request POST:/teams/{teamId}/service-accounts
   * @secure
   */
  serviceAccountsCreate = (
    teamId: string,
    data: ServiceAccountCreateRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<ServiceAccountResponseDto, ProblemDetails | void>({
      path: `/teams/${teamId}/service-accounts`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Lists the team's machine principals. **Returns:** `List<ServiceAccountResponseDto>`, excluding deleted accounts. **Permission:** Team Owner. **Error Codes:** `400 BadRequest` - Team not found. `401 Unauthorized` - Caller not authenticated. `403 Forbidden` - Caller is not an owner of the team. `500 InternalServerError` - Unexpected error.
   *
   * @tags ServiceAccounts
   * @name ServiceAccountsList
   * @summary List a Team's Service Accounts
   * @request GET:/teams/{teamId}/service-accounts
   * @secure
   */
  serviceAccountsList = (teamId: string, params: RequestParams = {}) =>
    this.request<ServiceAccountResponseDto[], ProblemDetails | void>({
      path: `/teams/${teamId}/service-accounts`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Renames a service account or changes its team permission. Both body fields are optional; omitted fields are left unchanged. **Behavior:** - The generated address is immutable. A credential is issued against it, so renaming it would silently break every caller holding one. - A new permission is capped at the caller's own. **Returns:** `ServiceAccountResponseDto`. **Permission:** Team Owner. **Error Codes:** `400 BadRequest` - Team or service account not found, or invalid permission. `401 Unauthorized` - Caller not authenticated. `403 Forbidden` - Caller is not an owner of the team, or asked for more permission than they hold. `500 InternalServerError` - Unexpected error.
   *
   * @tags ServiceAccounts
   * @name ServiceAccountsPartialUpdate
   * @summary Update a Service Account
   * @request PATCH:/teams/{teamId}/service-accounts/{serviceAccountId}
   * @secure
   */
  serviceAccountsPartialUpdate = (
    teamId: string,
    serviceAccountId: string,
    data: ServiceAccountUpdateRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<ServiceAccountResponseDto, ProblemDetails | void>({
      path: `/teams/${teamId}/service-accounts/${serviceAccountId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Disables a service account and revokes its access to the team. **Behavior:** - Removes the principal's team membership, which is what actually revokes its authority — every downstream check is a membership check. - Soft-deletes the principal so the assets it generated are not orphaned; they remain reachable by the team through the folders they live in. **Returns:** `204 No Content`. **Permission:** Team Owner. **Error Codes:** `400 BadRequest` - Team or service account not found. `401 Unauthorized` - Caller not authenticated. `403 Forbidden` - Caller is not an owner of the team. `500 InternalServerError` - Unexpected error.
   *
   * @tags ServiceAccounts
   * @name ServiceAccountsDelete
   * @summary Delete a Service Account
   * @request DELETE:/teams/{teamId}/service-accounts/{serviceAccountId}
   * @secure
   */
  serviceAccountsDelete = (
    teamId: string,
    serviceAccountId: string,
    params: RequestParams = {},
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/teams/${teamId}/service-accounts/${serviceAccountId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Issues an OAuth `client_credentials` credential for the service account, and returns the secret **once**. **Behavior:** - The response is the only time the secret is readable. It is stored hashed and cannot be recovered — a caller who loses it mints a new credential and revokes this one. - The credential is exchanged for a short-lived access token at `POST /connect/token` using the standard `client_credentials` grant. - Token claims are derived from the owning service account, so there is nothing to configure alongside the credential. - Defaults to a one-year lifetime; there is no way to ask for no expiry. **Rotating without an outage:** mint a second credential, deploy it, then revoke the first. Both are live in between, which is the point — an atomic rotate would break every caller at the moment of issue. **Returns:** `ServiceAccountCredentialCreatedResponseDto`, including `clientSecret`. **Permission:** Team Owner. **Error Codes:** `400 BadRequest` - Team or service account not found, invalid lifetime, or the account already holds the maximum number of live credentials. `401 Unauthorized` - Caller not authenticated. `403 Forbidden` - Caller is not an owner of the team. `500 InternalServerError` - Unexpected error.
   *
   * @tags ServiceAccounts
   * @name ServiceAccountsCredentialsCreate
   * @summary Mint a Service Account Credential
   * @request POST:/teams/{teamId}/service-accounts/{serviceAccountId}/credentials
   * @secure
   */
  serviceAccountsCredentialsCreate = (
    teamId: string,
    serviceAccountId: string,
    data: ServiceAccountCredentialCreateRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<
      ServiceAccountCredentialCreatedResponseDto,
      ProblemDetails | void
    >({
      path: `/teams/${teamId}/service-accounts/${serviceAccountId}/credentials`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Lists the account's credentials, including revoked and expired ones. **Behavior:** - Never returns secrets — only the client id, the last four characters, and lifecycle timestamps. - `lastUsedAt` is stamped when a credential is exchanged for an access token (roughly twice an hour for an active caller), not on every request, so a credential in use minutes ago may read as older than that. - Revoked credentials are listed rather than hidden: "this key existed, was last used on the 3rd, and was revoked on the 5th" is the question support gets asked. **Returns:** `List<ServiceAccountCredentialResponseDto>`, newest first. **Permission:** Team Owner. **Error Codes:** `400 BadRequest` - Team or service account not found. `401 Unauthorized` - Caller not authenticated. `403 Forbidden` - Caller is not an owner of the team. `500 InternalServerError` - Unexpected error.
   *
   * @tags ServiceAccounts
   * @name ServiceAccountsCredentialsList
   * @summary List a Service Account's Credentials
   * @request GET:/teams/{teamId}/service-accounts/{serviceAccountId}/credentials
   * @secure
   */
  serviceAccountsCredentialsList = (
    teamId: string,
    serviceAccountId: string,
    params: RequestParams = {},
  ) =>
    this.request<ServiceAccountCredentialResponseDto[], ProblemDetails | void>({
      path: `/teams/${teamId}/service-accounts/${serviceAccountId}/credentials`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Revokes one credential, leaving the service account and its other credentials alone. **This destroys the credential — it is not a disable.** The OAuth application behind it is deleted, and the hashed secret goes with it. There is no un-revoke: recovery means minting a new credential, which has a new client id, and updating every caller that holds the old one. **Behavior:** - The token endpoint refuses the secret immediately. - Access tokens already issued against it stay valid until they expire — at most `OpenIddictOptions:AccessTokenTTLMinutes` (30 by default). Revocation is immediate for new tokens, not retroactive for issued ones. - Idempotent: revoking an already-revoked credential succeeds. - Revoking the account's **last usable** credential takes the account offline and is refused unless `acknowledgeLastCredential=true` is passed. Every other revoke is a rotation step with a live credential still behind it; this one is not, and it cannot be undone. **Returns:** `204 No Content`. **Permission:** Team Owner. **Error Codes:** `400 BadRequest` - Team, service account or credential not found, or this is the account's last usable credential and `acknowledgeLastCredential` was not set. `401 Unauthorized` - Caller not authenticated. `403 Forbidden` - Caller is not an owner of the team. `500 InternalServerError` - Unexpected error.
   *
   * @tags ServiceAccounts
   * @name ServiceAccountsCredentialsDelete
   * @summary Revoke a Service Account Credential
   * @request DELETE:/teams/{teamId}/service-accounts/{serviceAccountId}/credentials/{credentialId}
   * @secure
   */
  serviceAccountsCredentialsDelete = (
    teamId: string,
    serviceAccountId: string,
    credentialId: string,
    query?: {
      /** @default false */
      acknowledgeLastCredential?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/teams/${teamId}/service-accounts/${serviceAccountId}/credentials/${credentialId}`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Retrieves all folders associated with a specific team. **Behavior:** - Validates that the team exists. - Retrieves team folders where the associated folder is not deleted. - Collects folder details including creation date, title, permissions, and creator info. **Returns:** `TeamFoldersResponseDto` containing a list of folder metadata associated with the team. **Permission:** Members of the team, plus the admin-console roles (SuperAdmin, Admin, ReadOnlySuperAdmin) and the support service account, which read any team. **Error Codes:** `400 BadRequest` - Team not found. `401 Unauthorized` - User not authenticated. `403 Forbidden` - Caller is not a member of the team and holds no cross-team read role. `500 InternalServerError` - Unexpected error.
   *
   * @tags Teams
   * @name FoldersList
   * @summary Get Team Folders
   * @request GET:/teams/{teamId}/folders
   * @secure
   */
  foldersList = (teamId: string, params: RequestParams = {}) =>
    this.request<TeamFoldersResponseDto, ProblemDetails | void>({
      path: `/teams/${teamId}/folders`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Fetches all projects associated with a team, optionally filtered by access type and geographical location. **Query Parameters:** `accesstype` (optional) - Filters the projects by the specified access type. `latitude`, `longitude`, `distance` (optional) - Filters projects by geographical location within the specified distance in meters. **Behavior:** - If `accesstype` is provided, returns only the projects where access matches the type. - Otherwise, returns all projects linked to the team. - Projects that are marked as deleted are excluded. - Populates project accessors and other relevant metadata. **Returns:** `List<ProjectResponseDto>` - A list of projects related to the specified team. **Permission:** User must be a member of the team. SuperAdmins can see all team projects. **Error Codes:** `400 BadRequest` - If the team ID is invalid, the request is malformed, or the user is not a member of the team. `401 Unauthorized` - If the user is not authenticated. `500 InternalServerError` - For unexpected server-side errors.
   *
   * @tags Teams
   * @name ProjectsList
   * @summary Get Team Projects
   * @request GET:/teams/{teamId}/projects
   * @secure
   */
  projectsList = (
    teamId: string,
    query?: {
      accesstype?: string;
      /** @format double */
      latitude?: number;
      /** @format double */
      longitude?: number;
      /** @format int32 */
      distance?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<ProjectResponseDto[], ProblemDetails | void>({
      path: `/teams/${teamId}/projects`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Fetches all scenes associated with a team, optionally filtered by access type, project ID, and geographical location. **Query Parameters:** `accesstype` (optional) - Filters scenes by access type. `projectId` (optional) - If set to "None", fetches available (unlinked) scenes. `latitude` (optional) - The latitude for filtering scenes by geographical location. `longitude` (optional) - The longitude for filtering scenes by geographical location. **Behavior:** - If both `accesstype` and `projectId=None` are provided, returns available scenes matching the access type. - If only `accesstype` is provided, returns scenes with the specified access type. - If only `projectId=None` is provided, returns available (unlinked) scenes. - If both `latitude` and `longitude` are provided, it filters scenes based on the geographical location. - Otherwise, returns all team scenes. - Deleted scenes are excluded. **Returns:** `List<SceneResponseDto>` - A list of scenes based on the criteria. **Permission:** User must be a member of the team. SuperAdmins can see all team scenes. **Error Codes:** `400 BadRequest` - If parameters are invalid, the request is malformed, or the user is not a member of the team. `401 Unauthorized` - If the user is not authenticated. `500 InternalServerError` - For unexpected server-side errors.
   *
   * @tags Teams
   * @name ScenesList
   * @summary Get Team Scenes
   * @request GET:/teams/{teamId}/scenes
   * @secure
   */
  scenesList = (
    teamId: string,
    query?: {
      accesstype?: string;
      projectId?: string;
      /** @format double */
      latitude?: number;
      /** @format double */
      longitude?: number;
      /** @format int32 */
      distance?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<SceneResponseDto[], ProblemDetails | void>({
      path: `/teams/${teamId}/scenes`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Fetches a list of teams. SuperAdmins can view all teams, while other users can only view teams associated with them. Optionally filter by team name. **Query Parameter:** `name` (optional) - Filters teams by the specified name. **Behavior:** - If `name` is provided, returns teams whose names match the filter. - If `name` is not provided, returns all teams for the current user or all teams for a superadmin. **Returns:** `List<UserTeamResponseDto>` - A list of teams associated with the current user or all teams for superadmins. **Permission:** The admin-console roles (SuperAdmin, Admin, ReadOnlySuperAdmin) and the support service account see every team. Everyone else sees only their own. `subscriptionType` is null for a team the caller neither belongs to nor may read billing for, so an Admin listing every team sees the teams but not their plan tiers. **Error Codes:** `400 BadRequest` - If the request is malformed or user not found. `401 Unauthorized` - If the user is not authenticated. `500 InternalServerError` - For unexpected server-side errors.
   *
   * @tags Teams
   * @name TeamsList
   * @summary Get Teams
   * @request GET:/teams
   * @secure
   */
  teamsList = (
    query?: {
      name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<UserTeamResponseDto[], ProblemDetails | void>({
      path: `/teams`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a new team and assigns members to it. The user making the request is automatically assigned as the team creator with owner permissions. **Request Body:** `TeamCreateRequestDto` - Contains the team information including name and members. **Behavior:** - The request body includes the team's name and members' emails along with their respective permissions. - The current user is automatically assigned as the team creator with 'Owner' permission. - If any member's email is not registered, an invitation will be sent to them for account creation and team membership. - A default folder for the team is created automatically. - A team folder is also created and associated with the team. - Members are assigned specific roles (e.g., 'Owner', 'Member') as per the request. **Returns:** `TeamCreateResponseDto` - Contains the newly created team's details along with the member emails. **Permission:** Any authenticated user can create a team. The creator is automatically assigned Owner permission. **Error Codes:** `400 BadRequest` - If the request is malformed or required fields are missing. `401 Unauthorized` - If the user is not authenticated. `500 InternalServerError` - For unexpected server-side errors.
   *
   * @tags Teams
   * @name TeamsCreate
   * @summary Insert a New Team
   * @request POST:/teams
   * @secure
   */
  teamsCreate = (data: TeamCreateRequestDto, params: RequestParams = {}) =>
    this.request<TeamCreateResponseDto, ProblemDetails | void>({
      path: `/teams`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Updates the details of an existing team, including its members, permissions, and access settings. This operation allows modifying team information, such as team name and associated members. Only teams that are not marked as default can be updated. **Request Body:** `TeamUpdateRequestDto` - Contains the fields to update, including: - `Members` (optional) - A list of members to be added or removed from the team with their respective permissions. - `RevokeAccess` (optional) - A list of users whose access to the team should be revoked. - `RevokeAccessUnregistered` (optional) - A list of unregistered users whose access should be revoked. - `UpdatePermissions` (optional) - A list of users whose permissions should be updated. **Behavior:** - The `teamId` specifies the team to be updated. - The operation checks if the team is not the default team. If it is not default, it will manage members and update the permissions accordingly. - The method handles both registered and unregistered users, revoking access where needed and updating permissions. - Updates to the team, such as the team name and description, are also applied. **Returns:** `No Content (204)` - If the update is successful and no content is returned. **Permission:** User must be a member of the team. Non-default teams only. **Error Codes:** `400 BadRequest` - If the team does not exist, the request is invalid, the team is a default team, or the user is not a member of the team. `401 Unauthorized` - If the user is not authenticated. `500 InternalServerError` - For unexpected server-side errors.
   *
   * @tags Teams
   * @name TeamsPartialUpdate
   * @summary Update a Team
   * @request PATCH:/teams/{teamId}
   * @secure
   */
  teamsPartialUpdate = (
    teamId: string,
    data: TeamUpdateRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/teams/${teamId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Fetches the details of a specific team by its ID. This operation allows users to view the information of a team they have access to. Only users who are members of the team can retrieve its details. **Path Parameter:** `teamId` - The unique identifier of the team to fetch details for. **Behavior:** - The method first checks if the team exists and is not marked as deleted. - It then verifies if the current user has access to the team. - If the user is not a member of the team, they will not be able to access the details. **Returns:** `TeamResponseDto` - The details of the team, including its name, description, and other relevant information. **Permission:** Members of the team, plus the admin-console roles (SuperAdmin, Admin, ReadOnlySuperAdmin) and the support service account, which read any team. `permissionType` is the caller's own permission on the team and is null when they are not a member. **Error Codes:** `400 BadRequest` - If the team does not exist. `401 Unauthorized` - If the user is not authenticated. `403 Forbidden` - Caller is not a member of the team and holds no cross-team read role. `500 InternalServerError` - For unexpected server-side errors.
   *
   * @tags Teams
   * @name TeamsDetail
   * @summary Get a Team
   * @request GET:/teams/{teamId}
   * @secure
   */
  teamsDetail = (teamId: string, params: RequestParams = {}) =>
    this.request<TeamResponseDto, ProblemDetails | void>({
      path: `/teams/${teamId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a team identified by the provided `teamId`. Only non-default teams can be deleted. A team that is marked as deleted will have its data removed permanently. **Path Parameter:** `teamId` - The unique identifier of the team to be deleted. **Behavior:** - The method first checks if the team exists. - It then verifies whether the team is a default team. Default teams cannot be deleted. - If the team is not a default team, it will be marked as deleted, and the deletion will be permanent. **Returns:** `204 No Content` - The team was successfully deleted. **Permission:** User must be a member of the team. Default teams cannot be deleted. **Error Codes:** `400 BadRequest` - If the team does not exist, it is a default team, or the user is not a member of the team. `401 Unauthorized` - If the user is not authenticated. `500 InternalServerError` - For unexpected server-side errors.
   *
   * @tags Teams
   * @name TeamsDelete
   * @summary Delete a Team
   * @request DELETE:/teams/{teamId}
   * @secure
   */
  teamsDelete = (teamId: string, params: RequestParams = {}) =>
    this.request<void, ProblemDetails | void>({
      path: `/teams/${teamId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Fetches a list of users associated with a specific team, identified by `teamId`. This includes both current team members and pending user invitations. **Path Parameter:** `teamId` - The unique identifier of the team for which the users are being fetched. **Behavior:** - The method retrieves a list of users who are currently members of the specified team and ensures that the team is not marked as deleted. - It also retrieves any pending invitations for users to join the team. **Returns:** `TeamUsersResponseDto` - A data transfer object containing the list of users and any pending invitations for the specified team. **Permission:** Members of the team, plus the admin-console roles (SuperAdmin, Admin, ReadOnlySuperAdmin) and the support service account, which read any team. **Error Codes:** `400 BadRequest` - If the request is malformed or the team does not exist. `401 Unauthorized` - If the user is not authenticated. `403 Forbidden` - Caller is not a member of the team and holds no cross-team read role. `500 InternalServerError` - For unexpected server-side errors.
   *
   * @tags Teams
   * @name UsersList
   * @summary Get Users of a Team
   * @request GET:/teams/{teamId}/users
   * @secure
   */
  usersList = (teamId: string, params: RequestParams = {}) =>
    this.request<TeamUsersResponseDto, ProblemDetails | void>({
      path: `/teams/${teamId}/users`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Fetches a list of subscription invoices associated with a specific team, identified by `teamId`. This operation returns all invoices related to the team's subscription in descending order of creation date. **Path Parameter:** `teamId` - The unique identifier of the team for which the subscription invoices are being fetched. **Behavior:** - The method retrieves all subscription invoices for the team identified by `teamId`. - The invoices are ordered by the date of creation in descending order, with the most recent invoices appearing first. **Returns:** `List<SubscriptionInvoiceResponseDto>` - A list of subscription invoices associated with the specified team. **Permission:** User must be a member of the team. **Error Codes:** `400 BadRequest` - If the request is malformed, an invalid team ID is provided, or the user is not a member of the team. `401 Unauthorized` - If the user is not authenticated. `500 InternalServerError` - For unexpected server-side errors.
   *
   * @tags Teams
   * @name SubscriptionInvoicesList
   * @summary Get Invoices for a Team Subscription
   * @request GET:/teams/{teamId}/subscription/invoices
   * @secure
   */
  subscriptionInvoicesList = (teamId: string, params: RequestParams = {}) =>
    this.request<SubscriptionInvoiceResponseDto[], ProblemDetails | void>({
      path: `/teams/${teamId}/subscription/invoices`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves the quota information of a specific team, identified by `teamId`. This includes details about the team's subscription, existing user count, active project count, and asset count. The response also includes pricing information based on the team's subscription type and add-ons, such as the project subscription amount and user amount. **Path Parameter:** `teamId` - The unique identifier of the team whose quota information is being fetched. **Behavior:** - The method retrieves the quota information for the specified team, including: - Subscription details (e.g., SKU, project and user subscription amounts, cancelation status). - Count of existing active users and active projects. - Count of assets within the team's folders. - The response will provide pricing information based on the team's current subscription, including any add-ons. **Returns:** `TeamSettingDto` - A data transfer object containing the team's quota details. **Permission:** User must be a member of the team. **Error Codes:** `400 BadRequest` - If the request is malformed, no team is found with the provided `teamId`, or the user is not a member of the team. `401 Unauthorized` - If the user is not authenticated. `500 InternalServerError` - For unexpected server-side errors.
   *
   * @tags Teams
   * @name QuotaList
   * @summary Get the Quota of a Team
   * @request GET:/teams/{teamId}/quota
   * @secure
   */
  quotaList = (teamId: string, params: RequestParams = {}) =>
    this.request<TeamSettingDto, ProblemDetails | void>({
      path: `/teams/${teamId}/quota`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description **DEPRECATED** — Use PUT instead. Updates the quota for a team to a custom configuration. SuperAdmin only.
   *
   * @tags Teams
   * @name QuotaCreate
   * @summary Customize the Quota of a Team (Deprecated)
   * @request POST:/teams/{teamId}/quota
   * @deprecated
   * @secure
   */
  quotaCreate = (
    teamId: string,
    data: CustomQuotaRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<TeamSettingDto, ProblemDetails | void>({
      path: `/teams/${teamId}/quota`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Allows updating the quota for a team, identified by `teamId`, to a custom configuration based on the provided `CustomQuotaRequestDto`. This method is meant for defining Quota for enterprise users hence it also handles subscription cancellation if an active subscription exists, updates the team’s settings based on the new SKU, and adjusts the expiration and current period end dates. **Path Parameter:** `teamId` - The unique identifier of the team whose quota is being updated. **Request Body:** `CustomQuotaRequestDto` - An object that specifies the desired quota settings such as `SKU`, `AssetsLimit`, `ProjectLimit`, `UserLimit`, etc. **Behavior:** - Cancels any existing subscription for the team (if any). - Updates the team's quota settings in the repository. - Adjusts the subscription period based on the provided SKU (monthly or yearly). - Calls services to lock assets, unpublish projects, and remove users based on the updated quota. **Returns:** `TeamSettingDto` - A data transfer object containing the updated quota details for the team. **Permission:** SuperAdmin only. Used for enterprise quota customization. **Error Codes:** `400 BadRequest` - If the `SKU` is invalid, the team does not exist, or the user does not have SuperAdmin permissions. `401 Unauthorized` - If the user is not authenticated. `500 InternalServerError` - For unexpected server-side errors.
   *
   * @tags Teams
   * @name QuotaUpdate
   * @summary Customize the Quota of a Team
   * @request PUT:/teams/{teamId}/quota
   * @secure
   */
  quotaUpdate = (
    teamId: string,
    data: CustomQuotaRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<TeamSettingDto, ProblemDetails | void>({
      path: `/teams/${teamId}/quota`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Allows a user to leave a team by removing their association with the team. This operation can only be executed by the user themselves. If the user is an owner of the team, the request will not be processed. The user must not have the 'Owner' permission to leave the team. **Path Parameters:** `teamId` - The unique identifier of the team the user wishes to leave. `userId` - The unique identifier of the user who wants to leave the team. **Behavior:** - The method checks if the requesting user is the same as the `userId` in the route. If not, a `BadRequestException` is thrown. - It then checks whether the user exists in the team and if their permission type is not 'Owner'. If the user is not found or is an owner, the operation won't continue. - Upon successful validation, the user’s team association is deleted. **Returns:** `204 No Content` - If the user successfully leaves the team. **Permission:** User can only remove themselves from the team. Owners cannot leave. **Error Codes:** `400 BadRequest` - If the requesting user does not match the `userId`, the user is not found in the team, or the user is an Owner (Owners cannot leave). `401 Unauthorized` - If the user is not authenticated. `500 InternalServerError` - For unexpected server-side errors.
   *
   * @tags Teams
   * @name UsersDelete
   * @summary Remove User from a Team
   * @request DELETE:/teams/{teamId}/users/{userId}
   * @secure
   */
  usersDelete = (teamId: string, userId: string, params: RequestParams = {}) =>
    this.request<void, ProblemDetails | void>({
      path: `/teams/${teamId}/users/${userId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Allows the upload of a team profile image and processes it into multiple sizes (full-size, thumbnail, and small thumbnail). The uploaded image is stored in Azure Blob Storage, and the corresponding URLs are saved in the team record. **Path Parameters:** `teamId` - The unique identifier of the team whose profile image is being set. **Request Body:** `teamProfileImageUploadRequestDto` - The DTO that contains the image file to be uploaded. **Behavior:** - The method checks if the team exists in the repository. - If the team exists, the image is processed and resized into multiple formats (full-size, thumbnail, small thumbnail). - The processed images are uploaded to Azure Blob Storage. - The URLs of the uploaded images (full-size, thumbnail, small thumbnail) are saved to the team's profile. **Returns:** `204 No Content` - If the profile image is successfully uploaded and saved. **Permission:** User must be a member of the team. **Error Codes:** `400 BadRequest` - If the team does not exist, the image upload fails, or the user is not a member of the team. `401 Unauthorized` - If the user is not authenticated. `500 InternalServerError` - For unexpected server-side errors during image processing or upload.
   *
   * @tags Teams
   * @name ProfileImageCreate
   * @summary Upload and Set Team Profile Image
   * @request POST:/teams/{teamId}/profile-image
   * @secure
   */
  profileImageCreate = (
    teamId: string,
    data: {
      /** @format binary */
      Image: File;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/teams/${teamId}/profile-image`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * @description Removes the team's profile image and its associated thumbnails from both the database and Azure Blob Storage. The profile image and its thumbnails are deleted if they exist, and the corresponding URLs are cleared from the team's record. **Path Parameters:** `teamId` - The unique identifier of the team whose profile image is being deleted. **Behavior:** - The method checks if the team exists. - If the team exists, it deletes the profile image and its thumbnails from Azure Blob Storage. - The URLs of the deleted images are then cleared from the team's record. **Returns:** `204 No Content` - If the profile image is successfully deleted. **Permission:** User must be a member of the team. **Error Codes:** `400 BadRequest` - If the team does not exist or the user is not a member of the team. `401 Unauthorized` - If the user is not authenticated. `500 InternalServerError` - For unexpected server-side errors during the deletion process.
   *
   * @tags Teams
   * @name ProfileImageDelete
   * @summary Delete Team Profile Image
   * @request DELETE:/teams/{teamId}/profile-image
   * @secure
   */
  profileImageDelete = (teamId: string, params: RequestParams = {}) =>
    this.request<void, ProblemDetails | void>({
      path: `/teams/${teamId}/profile-image`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Fetches the list of catalog packs associated with a specific team. This retrieves the team's catalogs from the database, maps them to response DTOs, and returns the list of catalog packs for that team. **Path Parameters:** `teamId` - The unique identifier of the team whose catalog packs are being retrieved. **Behavior:** - The method fetches the catalogs associated with the provided `teamId`. - If catalogs are found, they are returned as a list of `CatalogResponseDto` objects. - If no catalogs are found, it will return an empty list. **Returns:** `200 OK` - A list of catalogs associated with the team. **Permission:** Caller must be a member of the team, at any permission level, or hold a role with org-wide content visibility. **Error Codes:** `400 BadRequest` - If there is an issue with the team ID or the request is invalid. `401 Unauthorized` - If the user is not authenticated. `403 Forbidden` - If the caller is not a member of the team and holds no org-wide content role. `500 InternalServerError` - For unexpected server-side errors.
   *
   * @tags Teams
   * @name PacksList
   * @summary Get Team Packs
   * @request GET:/teams/{teamId}/packs
   * @secure
   */
  packsList = (teamId: string, params: RequestParams = {}) =>
    this.request<CatalogResponseDto[], ProblemDetails | void>({
      path: `/teams/${teamId}/packs`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Adds a catalog pack to a specific team. The pack is installed by creating a folder in the team's workspace and an entitlement row; the folder lists the pack's current items through the join, so a change to the pack is visible to the team on the next read. Installing is whole-pack: `assetIds` in the body is accepted and ignored. **Path Parameters:** `teamId` - The unique identifier of the team. `packId` - The unique identifier of the catalog pack to be added to the team. **Request Body:** `requestDto` - A DTO containing asset IDs that should be associated with the catalog pack for the team. **Behavior:** - The method checks if the team and catalog exist. - If the catalog pack has already been added to the team, the call is a no-op. - Otherwise a folder is created for the catalog pack, linked to the team, and associated with the catalog. No asset rows are written. **Returns:** `204 NoContent` - If the pack is successfully added to the team. **Permission:** Caller must be a member of the team with Editor or Owner permission. **Note:** Installed pack items are read-only in the workspace and do not count against the team asset quota; a private, editable copy is `POST /assets/{id}/copy`. **Error Codes:** `400 BadRequest` - If the catalog or team is not found, or the caller is not a member of the team with permission to write. `401 Unauthorized` - If the user is not authenticated. `500 InternalServerError` - For unexpected server-side errors.
   *
   * @tags Teams
   * @name PacksCreate
   * @summary Add Pack to Team
   * @request POST:/teams/{teamId}/packs/{packId}
   * @secure
   */
  packsCreate = (
    teamId: string,
    packId: string,
    data: PackToTeamDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/teams/${teamId}/packs/${packId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Removes a catalog pack from a specific team: the pack folder is soft-deleted and the entitlement removed. No asset rows or blobs are deleted. **Path Parameters:** `teamId` - The unique identifier of the team. `packId` - The unique identifier of the catalog pack to be removed from the team. **Behavior:** - The method checks if the team and catalog exist. - If the catalog is associated with the team, the pack folder is soft-deleted and the catalog is disassociated from the team. - Nothing is deleted from storage; an upload a user made into the pack folder stays restorable with the folder. **Returns:** `204 NoContent` - If the pack is successfully removed from the team. **Permission:** Caller must be a member of the team with Editor or Owner permission. **Error Codes:** `400 BadRequest` - If the catalog or team is not found, the catalog is not associated with the team, or the caller is not a member of the team with permission to write. `401 Unauthorized` - If the user is not authenticated. `500 InternalServerError` - For unexpected server-side errors.
   *
   * @tags Teams
   * @name PacksDelete
   * @summary Remove Pack from Team
   * @request DELETE:/teams/{teamId}/packs/{packId}
   * @secure
   */
  packsDelete = (teamId: string, packId: string, params: RequestParams = {}) =>
    this.request<void, ProblemDetails | void>({
      path: `/teams/${teamId}/packs/${packId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
}
